// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-modal-content .ant-modal-body {\n  padding: 50px 82px 32px !important;\n}\n.ant-modal-content .ant-form-item-explain {\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n.ant-modal-content .input-200 {\n  width: 218px !important;\n}\n", ""]);
// Exports
module.exports = exports;
